import { FlexLayout } from '@deity/falcon-ui';
import { Button, Icon, Input, Select } from '@deity-io/portal-ui';
import _ from 'lodash';
import type { FC } from 'react';
import { useState } from 'react';

type AddConstraintProps = {
  constraints: string[];
  constraintsProperties: {};
  onConstraintAdd: ({ type }: { type: string }) => void;
};
const AddConstraint: FC<AddConstraintProps> = ({ onConstraintAdd, constraints, constraintsProperties }) => {
  const [constraintType, setConstraintType] = useState<string | undefined>(undefined);
  const onAddConstraint = () => {
    const initVal = obj => {
      const defaultNativeValues = {
        string: undefined,
        boolean: false,
        number: undefined
      };
      if (!_.isUndefined(obj?.defaultValue)) {
        return obj.defaultValue;
      }
      if (!obj?.defaultValue && obj?.options?.length === 1) {
        return obj.options[0];
      }

      if (!obj?.defaultValue && obj?.type === 'list') {
        return [];
      }

      return defaultNativeValues[obj?.nativeType];
    };

    const initConstraintProps = properties =>
      Object.keys(properties)
        .filter(k => k !== 'references')
        .reduce(
          (acc, val) => ({
            ...acc,
            [properties[val].name]:
              properties[val].type !== 'field' && properties[val].type !== 'list'
                ? initConstraintProps(properties[val].properties)
                : initVal(properties[val])
          }),
          {}
        );

    if (constraintType) {
      const properties = constraintsProperties[constraintType];
      onConstraintAdd(initConstraintProps(properties));
      setConstraintType(undefined);
    }
  };

  return (
    <FlexLayout justifyContent="space-between" alignItems="center" mt="xs" mb="xs" p="xs" flexWrap="nowrap">
      <Select
        onChange={(c: any) => setConstraintType(c?.value)}
        options={constraints?.map(c => ({
          value: c,
          label: c
        }))}
        renderInput={params => <Input {...params} label="Validators" placeholder="Select validator" />}
      />
      <Button disabled={!constraintType} onClick={onAddConstraint} endIcon={<Icon icon="add" />} />
    </FlexLayout>
  );
};

export default AddConstraint;
